import { z } from 'zod'

import { SUPPLIER_RISK_LEVEL_OPTIONS } from '#app/routes/mocra+/_form+/components/suppliers/constants.ts'

export const SupplierEntrySchema = z.object({
	name: z
		.string({
			required_error: 'Enter the supplier or manufacturer name.',
		})
		.min(1, 'Enter the supplier or manufacturer name.'),
	materialScope: z
		.string({
			required_error:
				'Describe the ingredients, packaging, or service provided.',
		})
		.min(1, 'Describe the ingredients, packaging, or service provided.'),
	riskLevel: z.enum(
		SUPPLIER_RISK_LEVEL_OPTIONS.map((option) => option.value) as [
			(typeof SUPPLIER_RISK_LEVEL_OPTIONS)[number]['value'],
			...string[],
		],
	),
	qualityAgreementSigned: z.boolean().default(false),
	contactEmail: z.string().email('Enter a valid email.').optional(),
})

export type SupplierEntry = z.infer<typeof SupplierEntrySchema>
